// extracted by mini-css-extract-plugin
export default {"section":"HowToVoteModal_section__igAvq","sections":"HowToVoteModal_sections__t22CG"};